import * as React from 'react'

import type { AnalyticsFilterForm } from 'modules/enps/hooks/useAnalyticsMultiFilters'
import type EnpsForm from 'modules/enps/store/models/Form'

interface ContextProps {
  analyticsFilter: AnalyticsFilterForm | undefined
  form: EnpsForm | null | undefined
  loadingForm: boolean
  refreshForm: boolean
  setRefreshForm: (param: boolean) => void
  resultsFilter: AnalyticsFilterForm | undefined
  setAnalyticsFilter: (analyticsFilter: AnalyticsFilterForm) => void
  setResultsFilter: (resultsFilter: AnalyticsFilterForm) => void
}

export const EnpsFormContext = React.createContext<ContextProps>({
  analyticsFilter: undefined,
  form: null,
  loadingForm: true,
  refreshForm: false,
  setRefreshForm: () => {},
  resultsFilter: undefined,
  setAnalyticsFilter: () => {},
  setResultsFilter: () => {},
})
